import Api from "data/repository/Api";

export const getWizardDynoData = async (id) => {
    const res = await Api().get(`https://api.data.octalpowertrain.com/v1/dyno/vehicles/id/${id}`);
    return res.data;
};
